import { PaymentPlanKey } from 'api/clients/PaymentPlanClient'
import { AutopilotPlan } from 'components/Settings/Workspace/VirtualMarketerUpgradeCta/types'

export const LOW_CREDIT_THRESHOLD_RATIO = 0.1

export const findPlanCreditLimit = (plans: AutopilotPlan[], planKey: PaymentPlanKey): number => {
  const plan = plans.find((p) => p.key === planKey)
  const limit = plan?.prices[0]?.metadata?.credit_limit
  return limit != null ? Number(limit) : 0
}
